import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { withRouter } from 'react-router-dom';
import { makeStyles } from '@material-ui/core/styles';
import moment from 'moment';
import NewFilterWrap from 'components/molecules/NewFilterWrap';
import FilterCollection from 'components/organisms/FilterCollection';
import NewCommonFilter from 'components/organisms/NewCommonFilter';

import { adblockDayGraph } from 'lib/api/time';
import BarGraph from 'components/organisms/Chart/BarGraph';
import AdblockGraph from './AdblockGraph';
import AdblockPieGraph from './AdblockPieGraph';
import i18next from 'i18next';

const useStyles = makeStyles((theme) => ({
  contentBox: {
    width: '100%',
    display: 'flex',
    paddingBottom: 20,
  },
  pieGraphBox: {
    width: '40%',
    height: 500,
  },
  barGraphBox1: {
    width: '60%',
    marginLeft: 17,
    height: 520,
  },
  barGraphBox2: {
    width: '60%',
    marginLeft: 17,
    height: 520,
    overflowY: 'auto',
    overflowX: 'hidden',
  },
  dailyGraphBox: {
    paddingTop: 30,
  },
}));

const Statistics = ({ location }) => {
  const graphList = [
    {
      title: false,
      data: { bar: ['TOT_INFW_CNT'], line: ['INFW_CNT'] },
      yAxisData: {
        left: { TOT_INFW_CNT: true },
        right: { INFW_CNT: true },
      },
      referenceLine: {
        TOT_INFW_CNT: {
          type: 'average',
          label: i18next.t('전체 사용자 점유율'),
          visibleValue: true,
          color: 'rgb(51, 102, 255)',
        },
        INFW_CNT: {
          type: 'average',
          label: i18next.t('애드블록 점유율'),
          visibleValue: true,
          color: 'rgb(102, 0, 255)',
        },
      },

      customizeData: {
        INFW_CNT: {
          color: '#19CE60',
        },
        TOT_INFW_CNT: {
          color: '#EB483A',
        },
      },
    },
  ];

  const { t } = useTranslation();
  const classes = useStyles();
  const { pathname } = location;
  const [initialization, setInitialization] = useState(false);
  const initList = {
    group: [
      { label: '전체', value: '01' },
      { label: 'Device별', value: '02' },
      { label: 'Browser별', value: '03' },
      { label: 'OS별', value: '04' },
    ],
  };

  let initParams = {
    sort: 'desc',
    order: 'STATS_DTTM',
    sDate: moment().format('YYYYMM01'),
    eDate: moment().format('YYYYMMDD'),
    uri: pathname,
    group: '01',
  };

  const [params, setParams] = useState(initParams);

  /**
   * 필터 초기화 후 값을 바꿈
   */
  useEffect(() => {
    if (initialization === true) {
      setInitialization(false);
    } // eslint-disable-next-line
  }, [initialization]);

  /**
   * 필터 초기화
   */
  const handleOnReset = () => {
    setInitialization(true);
    setParams(initParams);
  };

  const getParam = (newParams) => {
    if (JSON.stringify(params) !== JSON.stringify(newParams)) {
      setParams(newParams);
    }
  };

  return (
    <>
      <NewFilterWrap handleOnReset={handleOnReset}>
        <NewCommonFilter
          initialization={initialization}
          params={params}
          getParam={getParam}
          useDisplayFilter={false}
          useExternalFilter={false}
          usePltfomTpCodeFilter={false}
        />
        <FilterCollection
          label={t('사용자구분')}
          name="group"
          params={params}
          value={params.group}
          type="radio"
          list={initList.group}
          callBack={getParam}
          labelKey="label"
          valueKey="value"
        />
      </NewFilterWrap>
      <div className={classes.contentBox}>
        <div className={classes.pieGraphBox}>
          <AdblockPieGraph params={params} />
        </div>
        <div
          className={
            params.group === '01' ? classes.barGraphBox1 : classes.barGraphBox2
          }
        >
          <AdblockGraph params={params} />
        </div>
      </div>
      <div className={classes.dailyGraphBox}>
        <BarGraph
          params={params}
          dataReqPromise={adblockDayGraph}
          graphList={graphList}
          title={t('일자별 유저 그래프')}
          labelType="MMDD"
        />
      </div>
    </>
  );
};

export default withRouter(Statistics);
